export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-12.4648ec44.jpg";